export enum AcceptedUploadType {
  PROFILE_IMAGES = 'image/jpeg, image/jpg, image/png'
}